import React, { FC, useContext, useEffect, useRef, useState } from 'react';

import { useQuery } from '@apollo/client';
import {
  BuildingIcon,
  DefaultImageIcon,
  H3,
  ShareIcon,
} from '@smartshell/ui-kit';
import cn from 'classnames';

import { AuthContext } from 'auth';
import { USER_CLUBS } from 'auth/schema';
import { IUserClubsResponse } from 'auth/types';
import { LocalizationContext } from 'localization';
import { fixTextFormatters } from 'utils';

import { INewsPreviewProps } from './interfaces';
import s from './NewsPreview.module.scss';

export const NewsPreview: FC<INewsPreviewProps> = ({ watch, linkButton }) => {
  const { t } = useContext(LocalizationContext);
  const {
    data: { tokens },
  } = useContext(AuthContext);

  const { data } = useQuery<IUserClubsResponse>(USER_CLUBS, {
    fetchPolicy: 'network-only',
  });

  const textRef = useRef<HTMLSpanElement>(null);
  const [showButton, setShowButton] = useState(false);

  const imagePreview = watch('image');
  const titlePreview = watch('title');
  const textPreview = watch('content');
  const textLinkPreview = watch('link.label');

  const encodedToken = atob(tokens?.access_token?.split('.')[1] ?? '');
  const clubId = encodedToken ? JSON.parse(encodedToken)?.company_id : null;

  const currentClub = data?.userClubs.find((club) => club.id === clubId);

  useEffect(() => {
    if (textRef.current) {
      const textHeight = textRef.current.clientHeight;
      setShowButton(textHeight > 167);
    }
  }, [textPreview]);

  return (
    <div className={s.container}>
      <H3>{t('news.preview')}</H3>

      <div className={s.preview}>
        <div className={s.image_block}>
          {imagePreview !== null && imagePreview !== '' ? (
            <>
              <div
                style={{
                  backgroundImage: `url(${imagePreview})`,
                }}
                className={s.image}
              />
              <div className={s.data}>1.06.2025</div>
            </>
          ) : (
            <div className={s.placeholder}>
              <DefaultImageIcon size="xxl" />
            </div>
          )}
        </div>

        <div className={s.content}>
          {titlePreview ? (
            <span className={s.title}>{titlePreview}</span>
          ) : (
            <div className={s.empty}></div>
          )}

          {textPreview ? (
            <span
              className={s.text}
              ref={textRef}
              dangerouslySetInnerHTML={{
                __html: fixTextFormatters(textPreview),
              }}
            ></span>
          ) : (
            <div className={cn(s.empty, s.empty_small)}></div>
          )}

          {showButton && (
            <button className={s.show_more}>Читать полностью</button>
          )}

          <div className={s.separator}></div>

          <div className={s.club}>
            <div className={s.left}>
              <BuildingIcon size="l" />
            </div>
            <div className={s.right}>
              <span className={s.title}>{currentClub?.name}</span>
              <span className={s.text}>{currentClub?.address}</span>
            </div>
          </div>

          {linkButton && (
            <div className={s.button_link}>
              <ShareIcon className={s.icon} size="m" color="primary" />
              {textLinkPreview && (
                <span className={s.link_text}>{textLinkPreview}</span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
